import { useCallback, useState } from "react";

import { v4 } from "uuid";

export type RejectedRequest = {
	statusCode: number;
};

type UseIdempotencyKeyResult = {
	idempotencyKey: string;
	rotateIdempotencyKey: () => void;
	rotateIdempotencyKeyIfRejected: (error: RejectedRequest) => void;
};

export function useIdempotencyKey(): UseIdempotencyKeyResult {
	const [idempotencyKey, setIdempotencyKey] = useState(() => {
		return v4();
	});

	const rotateIdempotencyKey = useCallback(() => {
		setIdempotencyKey(v4());
	}, []);

	const rotateIdempotencyKeyIfRejected = useCallback(
		({ statusCode }: RejectedRequest) => {
			// A 4xx means the backend rejected the request outright, so nothing was created and
			// replaying the key would only replay that rejection. 5xx and network failures leave
			// the outcome unknown, so the key must survive for the retry to stay idempotent.
			if (statusCode >= 400 && statusCode < 500) {
				rotateIdempotencyKey();
			}
		},
		[rotateIdempotencyKey],
	);

	return { idempotencyKey, rotateIdempotencyKey, rotateIdempotencyKeyIfRejected };
}
